export default [
    {
        "day": {
          "200": {
            "recommendation": "Stormy with a bit of rain. Coat required"
          },
          "201": {
            "recommendation": "Stormy with showers. Grab a brolly on your way out"
          },
          "202": {
            "recommendation": "It's going to be absolutely torrential out there today. Carry as many umbrellas as you can"
          },
          "210": {
            "recommendation": "Light storm on the way. Good time for that spare lightning detector you've had lying around"
          },
          "211": {
            "recommendation": "A storm on the way. Mind your eardrums please."
          },
          "212": {
            "recommendation": "Biblical weather today. Gumboots and a life jacket are the bare minimum"
          },
          "221": {
            "recommendation": "Horrid weather. Jackets, brollies, heck, you might even need a boat"
          },
          "230": {
            "recommendation": "Storms and a bit of rain. Brolly + layers I'm afraid"
          },
          "231": {
            "recommendation": "Rain + storms aka you'll look pretty daft going without a jacket today"
          },
          "232": {
            "recommendation": "Rainfall incoming. Umbrella for goodness sake!"
          },
          "300": {
            "recommendation": "Well, a bit of rain never killed anyone. Am I even legally allowed to say er... *frantically deletes*"
          },
          "301": {
            "recommendation": "Rain, but not terminal. Be sensible and wear a coat for heavens sake"
          },
          "302": {
            "recommendation": "Rain, of the annoying variety. Don't get caught out"
          },
          "310": {
            "recommendation": "The kind of rain you see people dance in in the movies. You'll be fine"
          },
          "311": {
            "recommendation": "A spot of rain. Nothing to be overly worried about"
          },
          "312": {
            "recommendation": "More rain, I'm afraid. Coat or jacket as standard"
          },
          "313": {
            "recommendation": "Showers forecasted. That means a free shower for you if you don't carry a brolly"
          },
          "314": {
            "recommendation": "Cats and dogs. Umbrella and a thick pair of wellies required."
          },
          "321": {
            "recommendation": "Rain, but the sort you could survive by staying indoors. Umbrella optional"
          },
          "500": {
            "recommendation": "You can get away with just a sweater today. Disclaimer: I will not be held responsible for any rain-related mishaps"
          },
          "501": {
            "recommendation": "A bit more rain. Best carry an umbrella chap"
          },
          "502": {
            "recommendation": "Now this is getting annoying. Umbrella + jacket required"
          },
          "503": {
            "recommendation": "Biblical amounts of rain forecasted. Umbrella, jacket, coat, layers, life jacket, and standby boat as standard"
          },
          "504": {
            "recommendation": "I'm delighted to tell you that you're not leaving the house today because you'd literally drown in the rain outside"
          },
          "511": {
            "recommendation": "Rain, biting cold, soul-renching conditions, the works. You'd be well advised to seek cover and remain indoors"
          },
          "520": {
            "recommendation": "Showers forecasted. Carry an umbrella for goodness sake!"
          },
          "521": {
            "recommendation": "Showers forecasted. Please carry an umbrella for goodness sake"
          },
          "522": {
            "recommendation": "You're getting absolutely drenched if you dare go without a military-grade jacket and umbrella combo today"
          },
          "531": {
            "recommendation": "Ragged rains. You're going to need a jacket, wellies and industrial-strength fortitude to make it through this"
          },
          "600": {
            "recommendation": "Light snow forecasted. You'll be fine"
          },
          "601": {
            "recommendation": "Snow. But you'll live. Just carry a sweater for good measure"
          },
          "602": {
            "recommendation": "It's blustery out there. Consider calling in sick at the office"
          },
          "611": {
            "recommendation": "Umbrella and coat as standard"
          },
          "612": {
            "recommendation": "Umbrella and coat as standard"
          },
          "613": {
            "recommendation": "Umbrella and coat as standard"
          },
          "615": {
            "recommendation": "Umbrella and coat as standard. Don't say I didn't warn you"
          },
          "616": {
            "recommendation": "Umbrella + coat + a nice cup of a warm beverage recommended"
          },
          "620": {
            "recommendation": "A light jacket should do the trick"
          },
          "621": {
            "recommendation": "Rain + snow. Could be better. Could be worse. Jacket + brolly recommended"
          },
          "622": {
            "recommendation": "It's an absolute warzone out there. Coat, umbrella, jacket and military-grade helmet required"
          },
          "701": {
            "recommendation": "The air is thick with fog and there's just barely a light rain. Tread carefully"
          },
          "702": {
            "recommendation": "Do you smell burning? I smell burning..."
          },
          "711": {
            "recommendation": "Smoke warning - potential forest fire hazard. Be extremely vigilant and on the lookout for the most up to date weather advisories"
          },
          "721": {
            "recommendation": "The sun's out but it's hazy. I've got work, but I'm lazy. Like a mini Eminem, right?"
          },
          "731": {
            "recommendation": "Like walking out in the Sahara is what it looks like out there. Tech wear the absolute bare minimum"
          },
          "741": {
            "recommendation": "Foggy weather. Visibility severely impacted. Take extreme care when driving if you must."
          },
          "751": {
            "recommendation": "Potential sandstorms expected. Avoid the outdoors if you can"
          },
          "761": {
            "recommendation": "Potential dust storms expected. Take cover and remain safe"
          },
          "762": {
            "recommendation": "Volcanic ash advisory - stay indoors whenever possible"
          },
          "771": {
            "recommendation": "Snow squall warning - avoid the outdoors if you can"
          },
          "781": {
            "recommendation": "Tornado warning - take immediate cover at the first sign. Avoid windows."
          },
          "800": {
            "recommendation": "It's a beautiful day. Lather up on some sunscreen and maybe carry a hat too for good measure."
          },
          "801": {
            "recommendation": "Great day for a hanging out the laundry and maybe a nice picnic date later :)"
          },
          "802": {
            "recommendation": "Love is in the air. Call that special someone up for a coffee"
          },
          "803": {
            "recommendation": "'Netflix and chill' weather. It's pleasant outside"
          },
          "804": {
            "recommendation": "Great day for a run. Pack that gym bag"
          }
        },
        "night": {
          "200": {
            "recommendation": "Stormy with a bit of rain. Coat required"
          },
          "201": {
            "recommendation": "Stormy with showers. Grab a brolly on your way out"
          },
          "202": {
            "recommendation": "It's going to be absolutely torrential out there. Carry as many umbrellas as you can"
          },
          "210": {
            "recommendation": "Light storm on the way. Good time for that spare lightning detector you've had lying around"
          },
          "211": {
            "recommendation": "A storm on the way. Mind your eardrums please."
          },
          "212": {
            "recommendation": "Biblical weather today. Gumboots and a life jacket are the bare minimum"
          },
          "221": {
            "recommendation": "Horrid weather. Jackets, brollies, heck, you might even need a boat"
          },
          "230": {
            "recommendation": "Storms and a bit of rain. Brolly + layers I'm afraid"
          },
          "231": {
            "recommendation": "Rain + storms aka you'll look pretty daft going without a jacket today"
          },
          "232": {
            "recommendation": "Rainfall incoming. Umbrella for goodness sake!"
          },
          "300": {
            "recommendation": "Well, a bit of rain never killed anyone. Am I even legally allowed to say er... *frantically deletes*"
          },
          "301": {
            "recommendation": "Rain, but not terminal. Be sensible and wear a coat for heavens sake"
          },
          "302": {
            "recommendation": "Rain, of the annoying variety. Don't get caught out"
          },
          "310": {
            "recommendation": "The kind of rain you see people dance in in the movies. You'll be fine"
          },
          "311": {
            "recommendation": "A spot of rain. Nothing to be overly worried about"
          },
          "312": {
            "recommendation": "More rain, I'm afraid. Coat or jacket as standard"
          },
          "313": {
            "recommendation": "Showers forecasted. That means a free shower for you if you don't carry a brolly"
          },
          "314": {
            "recommendation": "Cats and dogs. Umbrella and a thick pair of wellies required."
          },
          "321": {
            "recommendation": "Rain, but the sort you could survive by staying indoors. Umbrella optional"
          },
          "500": {
            "recommendation": "You can get away with just a sweater today. Disclaimer: I will not be held responsible for any rain-related mishaps"
          },
          "501": {
            "recommendation": "A bit more rain. Best carry an umbrella chap"
          },
          "502": {
            "recommendation": "Now this is getting annoying. Umbrella + jacket required"
          },
          "503": {
            "recommendation": "Biblical amounts of rain forecasted. Umbrella, jacket, coat, layers, life jacket, and standby boat as standard"
          },
          "504": {
            "recommendation": "I'm delighted to tell you that you're not leaving the house today because you'd literally drown in the rain outside"
          },
          "511": {
            "recommendation": "Rain, biting cold, soul-renching conditions, the works. You'd be well advised to seek cover and remain indoors"
          },
          "520": {
            "recommendation": "Showers forecasted. Carry an umbrella for goodness sake!"
          },
          "521": {
            "recommendation": "Showers forecasted. Please carry an umbrella for goodness sake"
          },
          "522": {
            "recommendation": "You're getting absolutely drenched if you dare go without a military-grade jacket and umbrella combo today"
          },
          "531": {
            "recommendation": "Ragged rains. You're going to need a jacket, wellies and industrial-strength fortitude to make it through this"
          },
          "600": {
            "recommendation": "Light snow forecasted. You'll be fine"
          },
          "601": {
            "recommendation": "Snow. But you'll live. Just carry a sweater for good measure"
          },
          "602": {
            "recommendation": "It's blustery out there. Consider calling in sick at the office"
          },
          "611": {
            "recommendation": "Umbrella and coat as standard"
          },
          "615": {
            "recommendation": "Umbrella and coat as standard. Don't say I didn't warn you"
          },
          "616": {
            "recommendation": "Umbrella + coat + a nice cup of a warm beverage recommended"
          },
          "620": {
            "recommendation": "A light jacket should do the trick"
          },
          "621": {
            "recommendation": "Rain + snow. Could be better. Could be worse. Jacket + brolly recommended"
          },
          "622": {
            "recommendation": "It's an absolute warzone out there. Coat, umbrella, jacket and military-grade helmet required"
          },
          "701": {
            "recommendation": "The air is thick with fog and there's just barely a light rain. Tread carefully"
          },
          "702": {
            "recommendation": "Do you smell burning? I smell burning..."
          },
          "711": {
            "recommendation": "Smoke warning - potential forest fire hazard. Be extremely vigilant and on the lookout for the most up to date weather advisories"
          },
          "721": {
            "recommendation": "Silent night, hazy night... you'll need your standard-issue mil-spec night vision goggles"
          },
          "731": {
            "recommendation": "Like walking out in the Sahara is what it looks like out there. Tech wear the absolute bare minimum"
          },
          "741": {
            "recommendation": "Foggy weather. Visibility severely impacted. Take extreme care when driving if you must."
          },
          "751": {
            "recommendation": "Potential sandstorms expected. Avoid the outdoors if you can"
          },
          "761": {
            "recommendation": "Potential dust storms expected. Take cover and remain safe"
          },
          "762": {
            "recommendation": "Volcanic ash advisory - stay indoors whenever possible"
          },
          "771": {
            "recommendation": "Snow squall warning - avoid the outdoors if you can"
          },
          "781": {
            "recommendation": "Tornado warning - take immediate cover at the first sign. Avoid windows."
          },
          "800": {
            "recommendation": "Clear skies. Kind of night where you fire up stellarium and cozy up underneath the telescope"
          },
          "801": {
            "recommendation": "Cloudy skies on a blustery evening. Snuggle up with a hot cuppa"
          },
          "802": {
            "recommendation": "Cloudy gusts forecasted. You'll wanna get a coat"
          },
          "803": {
            "recommendation": "Cloudy and blustery outside. Coat required"
          },
          "804": {
            "recommendation": "Cloudy with a chance of meatballs"
          },
          "900": {
            "recommendation": "⚠️ Tornado warning ⚠️ Seek safe shelter immediately. stay away from doors, windows, outside walls and protect your head!"
          },
          "902": {
            "recommendation": "⚠️ Hurricane warning ⚠️ Stay indoors and away from windows. Be on the lookout for the latest emergency response information"
          },
          "903": {
            "recommendation": "Snowflakes falling with a chilly wind blowing. Christmas already?"
          },
          "904": {
            "recommendation": "Absolutely blazing outside. Ice baths on rotation is the bare minimum"
          },
          "906": {
            "recommendation": "Hailstorm forecasted. Take cover"
          },
          "957": {
            "recommendation": "Strong winds. Hold on to something or someone strong"
          }
        }
      }
];